import moment from "moment";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Button, Col, Row } from "reactstrap";
import * as url from 'src/helpers/url_helper';
import store from "src/rtk/app/store";
import {
    useCreateByPostFormCommentsMutation,
    useGetCommentsDataByMutation,
} from 'src/rtk/features/disertation-thesis/crudApi';

const CommentSection = (props: any) => {

    const { thesisDissertationFile, thesisDissertationFormSetupId, thesisDissertationFormSetupColumnName, setMessageCount } = props;

    const [messages, setMessages] = useState<any>([]);
    const [comment, setComment] = useState<any>({});

    const currentUser: any = store.getState().auth.user;

    const [
        createByPostComment,
        {
            isSuccess: isCommentSuccess,
            isLoading: isCommentLoading,
            isError: isCommentError,
            error: commentError,
        },
    ] = useCreateByPostFormCommentsMutation();

    const [
        commentsDataList,
        {
            isLoading: commentsDataListLoading,
            isSuccess: commentsDataListLoadingSuccess,
            error: commentsDataListLoadingError,
        },
    ] = useGetCommentsDataByMutation();

    const getCommentsData = (thesis_dissertation_id: string, column_id: string) => {
        commentsDataList(`${url.THESIS_DISSERTATION_ENTRY_COMMENT_LIST}/${thesis_dissertation_id}/${column_id}`).then(function (result: any,) {
            // here you can use the result of promiseB
            if (result?.data?.data) {
                setMessages(result?.data?.data);
                setMessageCount(result?.data?.data);
            }
        });

        // setMessage(commentsData?.data || []);
    };

    useEffect(() => {
        if (isCommentSuccess) {
            getCommentsData(thesisDissertationFile?.data?.id, thesisDissertationFormSetupId);
            toast.dismiss();
        }
        if (isCommentError) {
            toast.dismiss();
            // toast.error('Something went wrong');
        }
    }, [isCommentLoading, isCommentSuccess, isCommentError]);

    useEffect(() => {
        getCommentsData(thesisDissertationFile?.data?.id, thesisDissertationFormSetupId);
    }, []);

    return (
        <>
            <Row>
                <Col sm={12}>
                    {/* <Label
                        className={
                            'form-label me-2 text-capitalize'
                        }
                    >
                        Comments for {fieldLabel}
                    </Label> */}
                    <div className="border rounded">
                        <div
                            className="chat-conversation p-3 px-2"
                            style={{
                                height: '425px',
                                overflow:
                                    'auto',
                            }}
                        >
                            <ul className="list-unstyled">
                                {messages &&
                                    messages.map(
                                        (
                                            message: any,
                                        ) => {
                                            return (
                                                <li
                                                    key={'test_k' + message.id}
                                                    className={message?.registration_id === currentUser?.registration_no ? 'right' : ''}
                                                >
                                                    <div className="conversation-list">
                                                        <div className="ctext-wrap">
                                                            <div className="ctext-wrap-content">
                                                                {
                                                                    message?.registration_id ===
                                                                        currentUser?.registration_no
                                                                        ? (<h5 className="conversation-name">
                                                                            <span className="time me-0">
                                                                                {moment(message.updated_at,).calendar()}
                                                                            </span>
                                                                        </h5>)
                                                                        : (<h5 className="conversation-name">
                                                                            <div className="user-name me-2 text-white">
                                                                                {
                                                                                    message.name
                                                                                }
                                                                            </div>
                                                                            <div className="user-name text-white">
                                                                                ({
                                                                                    message.type
                                                                                })
                                                                            </div>
                                                                            <span className="time">
                                                                                {moment(message.updated_at,).calendar()}
                                                                            </span>
                                                                        </h5>)
                                                                }

                                                                <p className="mb-0" dangerouslySetInnerHTML={{ __html: message.comments }}>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            );
                                        },
                                    )}
                            </ul>
                        </div>
                        <div className="p-3 border-top">
                            <Row>
                                <Col>
                                    <div className="position-relative">
                                        <input
                                            type="textarea"
                                            name={'comment'}
                                            value={comment[thesisDissertationFormSetupColumnName] || ''}
                                            onChange={(e: any, key: any = thesisDissertationFormSetupColumnName,) => {
                                                let message = e.target.value || '';

                                                let newComment = {
                                                    ...comment,
                                                    [key]: message,
                                                };


                                                setComment(newComment,);
                                            }}
                                            className="form-control border bg-soft-light"
                                            placeholder={'Enter comment for ' + thesisDissertationFormSetupColumnName}
                                        />
                                    </div>
                                </Col>
                                <Col className="col-auto">
                                    <Button
                                        type="button"
                                        color="primary"
                                        onClick={() => {
                                            if (comment[thesisDissertationFormSetupColumnName]) {

                                                let postCommentData =
                                                {
                                                    queryUrl: url.THESIS_DISSERTATION_ENTRY_COMMENT_SUBMIT,
                                                    formData:
                                                    {
                                                        thesis_dissertation_id: thesisDissertationFile?.data?.id,
                                                        colum_id: thesisDissertationFormSetupId,
                                                        comments: comment[thesisDissertationFormSetupColumnName] || '',
                                                        column_name: thesisDissertationFormSetupColumnName,
                                                    },
                                                };

                                                createByPostComment(postCommentData,).then(
                                                    (
                                                        res: any,
                                                    ) => {
                                                        if (
                                                            res.data?.success
                                                        ) {
                                                            comment[thesisDissertationFormSetupColumnName];

                                                            let newComment =
                                                            {
                                                                ...comment,
                                                                [thesisDissertationFormSetupColumnName]: "",
                                                            };

                                                            setComment(newComment,);

                                                        }
                                                    },
                                                );
                                            }
                                        }}
                                        className="btn btn-success chat-send w-md"
                                        disabled={
                                            isCommentLoading
                                        }
                                    >
                                        <span className="d-none d-sm-inline-block me-2">
                                            {isCommentLoading
                                                ? 'Sending...'
                                                : 'Send'}
                                        </span>{' '}
                                        <i className="mdi mdi-send float-end" />
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
};

export default CommentSection;